import { render, staticRenderFns } from "./DebugPanel.vue?vue&type=template&id=35f378fc&"
import script from "./DebugPanel.vue?vue&type=script&lang=js&"
export * from "./DebugPanel.vue?vue&type=script&lang=js&"
import style0 from "./DebugPanel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DebugPanel.vue"
export default component.exports